import { Link, Text, TextType, useTheme } from '@defa/defa-component-library';

import i18n from '../../i18n';
import { SupportSectionRoot } from './support-section.styles';

export function SupportSection() {
    const theme = useTheme();

    return (
        <SupportSectionRoot>
            <Text type={TextType.body} color={theme.foreground.alternative}>
                {i18n.t('support.description')}{' '}
                <Link href="https://cloudcharge.tech/support/contact/" inline newTab>
                    {i18n.t('support.linkText')}
                </Link>
            </Text>
        </SupportSectionRoot>
    );
}
